<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Select from "@/components/c-select";
import Input from "@/components/c-input";
import Button from "@/components/c-button";
import moment from 'moment'
import { bookingReportService } from "../../../../services/reportservice/bookingreportservice.js";


/* eslint-disable no-console */
export default {
  page: {
    title: "Daily Booking Report",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { 
    Layout, 
    PageHeader, 
    Button,
    Input,
    Select, 
  },
  data() {
    return {
      title: "Daily Booking Report",
      data: [],
      projects: {},
      project_name: 'HRSS',

      dataStartDate: '',
      dataEndDate: '',
      dataProjectId: 0,
    };
  },
  mounted() {
    //this.loadingData(this.$route.params.id);
    this.loadingData();
    
  },
  methods: {
    
     
    loadingData: function() {
      
      bookingReportService.getDailyBooking()
        .then(response => {
          this.data = response.data.booking;
          this.dataStartDate = response.data.date.start_date;
          this.dataEndDate = response.data.date.end_date;
          this.projects = response.data.project;
        });
    },
    submitSearch: function() {
      let data = '?project_id='+this.dataProjectId+'&start_date='+this.dataStartDate+'&end_date='+this.dataEndDate
      bookingReportService.getDailyBooking(data)
        .then(response => {
            this.data = response.data.booking;
            this.dataStartDate = response.data.date.start_date;
            this.dataEndDate = response.data.date.end_date;
            this.projects = response.data.project;
      });
    },
    dateFormat: function(value){
      return moment(String(value)).format('DD/MM/YYYY');
    },
    discountPrice(price, discount, dis_type) {
        let total = 0;
        if(dis_type==1){
          total = price * discount / 100;
        }else{
          total = discount
        }
        return total
    },
    formatCurrency(value) {
      if(value == 0 ){
        return '';
      }
      let sign = '$';
      let decimal = ''; //'.00';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);

      // return value;
    },
    print() {
      window.print();
    }
  },
  computed: {
    totalPrice() {
      return this.data.reduce(function (sum, item) {
        return sum + item.sale_price
      }, 0)
    },
    totalDiscount() {
      return this.data.reduce(function (sum, item) {
        let total = 0;
        if(item.discount_type == 1){
          total = sum + (item.sale_price * item.discount / 100);
        }else{
          total = sum + item.discount;
        }
        return total;
      }, 0)
    },
    totalSalePrice() {
      return this.data.reduce(function (sum, item) {
        let total = 0;
        if(item.discount_type == 1){
          total = sum + (item.sale_price - (item.sale_price * item.discount / 100));
        }else{
          total = sum + (item.sale_price - item.discount);
        }
        return total
      }, 0)
    }
    
  }
};

</script>

<template>
  <Layout>
    <PageHeader @click="print()" :add="{icon: 'bx bx-printer', title: 'general.print'}" :title="$t('report.booking.daily')" />
      <div id="print-area">
        <!-- <center> -->
          <div class="row search-area">
              
              <div class="col-sm-2">
                <Select
                  :id="'id'"
                  :text="'label'"
                  :editable="true"
                  :list="{data: this.projects}"
                  v-model="dataProjectId"
                /> 
              </div>
              <div class="col-sm-2">
                <Input 
                  :type="'date'"
                  :id="'start_date'"
                  v-model="dataStartDate"
                /> 
              </div>
              <div class="col-sm-2">
                <Input 
                  :type="'date'"
                  :id="'end_date'"
                  v-model="dataEndDate"
                /> 
              </div>
              <div class="col-sm-2">
                <Button v-bind:icon="'bx bx-search'"
                  @click="submitSearch()" 
                  v-bind:buttonType="'button'"
                  v-bind:variant="'primary'"
                  v-bind:title="$t('general.search')" 
                />
              </div>
          </div>
          <div class="col dblack box-a4l">
            <table width="100%" class="content-general bottom">
              <tr>
                <td width="9%"><p>&nbsp;</p></td>
                <td width="50%"><p>&nbsp;</p></td>
              </tr>
              <tr>
                <td><img src="@/assets/images/h-logo.svg" alt width="80" /></td>
                <td>
                  <p class="khb h4"><b>ក្រុមហ៊ុនលំនៅឋាន<span class="g-color"> អេចស៊ី </span>ឯ.ក</b></p>
                  <p class="enb h5"><b>LOMNOV THAN <span class="g-color">HC</span> CO., LTD</b></p>
                  <p class="khs h8">អាសយដ្ឋានដីឡូតិ៍លេខៈ ៧៤២ ផ្លូវលេខៈ ១៩៥២ ភូមិបាយ៉ាប សង្កាត់ភ្នំពេញថ្មី ខណ្ឌសែនសុខ រាជធានីភ្នំពេញ</p>
                  <p class="khs h8">ទូរស័ព្ទលេខៈ 092 685 009 | 098 685 009 Email: account@h-residence.net</p>
                </td>
                <td class="">
                    <p class=""><u>{{$t('report.booking.daily')}}</u></p>
                    <p class=""><u>ប្រចាំខែ: {{this.dateFormat(this.dataStartDate)}} - {{this.dateFormat(this.dataEndDate)}}</u></p>
                    <p class=""><u>គម្រោង: {{this.project_name}}</u></p>
                </td>
              </tr>
              
            </table>
            <br/>
       
            <div class="row">
                <div class="col-sm-12">
                    <table class="content-general h8 project-sumary-table" width="100%">
                       
                            <tr class="thead">
                                <th>#</th>
                                <th>{{$t('report.booking.code')}}</th>
                                <th>{{$t('report.booking.customer-name')}}</th>
                                <th>{{$t('report.booking.project')}}</th>
                                <th>{{$t('report.booking.unit')}}</th>
                                <th>{{$t('report.booking.price')}}</th>
                                <th>{{$t('report.booking.discount')}}</th>
                                <th>{{$t('report.booking.sale-price')}}</th>
                                <th>{{$t('report.booking.deposite')}}</th>
                                <th>{{$t('report.booking.booking-date')}}</th>
                                <th>{{$t('report.booking.expired-date')}}</th>
                            </tr>
                        
                        <tbody>
                            <tr v-for="(list, index) in data" :key="index" >

                            <td>{{index + 1}}</td>
                            <td>{{list.code}}</td>
                            <td>{{list.customer_name}}</td>
                            <td>{{list.project_name}}</td>
                            <td>{{list.property_name}}</td>
                            <td>{{formatCurrency(list.price)}}</td>
                            <td>{{formatCurrency(list.discount)}}</td>
                            <td>{{formatCurrency(list.sale_price)}}</td>
                            <td>{{formatCurrency(list.booking_amount)}}</td>
                            <td>{{dateFormat(list.booking_date)}}</td>
                            <td>{{dateFormat(list.expire_date)}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
       
            <div class="row mt-3">
              <div class="col">
                <center>
                  <p>បានពិនិត្យនិងឯកភាព<br>អគ្គនាយកក្រុមហ៊ុន</p>
                </center>
              </div>
              <div class="col">
                <center>
                  <p>បានពិនិត្យនិងឯកភាព<br>អគ្គនាយកក្រុមហ៊ុន</p>
                </center>
              </div>
              <div class="col">
                <center>
                  <p>បានពិនិត្យនិងឯកភាព<br>នាយកផ្នែកបច្ចេកទេស</p>
                </center>
              </div>
              <div class="col">
                <center>
                  <p>បានពិនិត្យនិងឯកភាព<br>ប្រធានគ្រប់គ្រងទូទៅ</p>
                </center>
              </div>
              <div class="col">
               
              </div>
            </div>
          </div>  
        <!-- </center> -->
      </div>
    <!-- end row -->
  </Layout>
</template>